<template>
  <div>
    <div class="no_result" v-if="addrArr.length == 0">
      <img src="../../assets/images/icon_6.png" />
      <p>你还没有添加地址哦~</p>
      <a href="javascript:void(0)" @click="addressAdd">添加地址</a>
    </div>
    <div class="title" v-if="addrArr.length != 0">
      <span>已保存收货地址</span>
      <a href="javascript:void(0)" @click="addressAdd">+ 新建地址</a>
    </div>
    <div class="addr_list" v-if="addrArr.length != 0">
      <div class="addr_title">
        <h3 class="name">收货人</h3>
        <h3 class="addr">地址</h3>
        <h3 class="cont">联系方式</h3>
        <h3 class="oper">操作</h3>
      </div>
      <ul class="addr_box" v-for="(item,index) in addrArr" :key="index">
        <li class="name">
          <em class="name">{{item.name}}</em>
        </li>
        <li class="addr">
          <em class="addr">{{addrSplit(item.addrNameFull)}}{{item.detailAddress}}</em>
        </li>
        <li class="cont">
          <em class="cont">{{item.phone}}</em>
        </li>
        <li class="oper">
          <em class="oper">
            <span @click="editAddress(item.id,item.name,item.phone,item.postCode,item.addrNameFull,item.detailAddress,item.defaultStatus)">编辑</span>
            <span @click="delAddress(item.id)">删除</span>
          </em>
        </li>
        <li class="othe">
          <em>
            <span class="normal" v-if="item.defaultStatus == 1">默认地址</span>
            <span class="active" v-if="item.defaultStatus == 0" @click="setDefault(item.id,item.name,item.phone,item.postCode,item.detailAddress)">设为默认地址</span>
          </em>
        </li>
      </ul>
    </div>
    <!-- 添加地址 -->
    <div class="yu_mask" v-if="addressShow == 1">
      <div class="address_add">
        <h3 class="title">添加地址</h3>
        <div class="label">
          <div class="left">所在地区：</div>
          <div class="right">
            <!-- 省市区列表 -->
            <v-distpicker :placeholders="placeholders" :province="select.province" :city="select.city" :area="select.area" @selected="onSelected"></v-distpicker>
          </div>
        </div>
        <div class="label">
          <div class="left">详情地址：</div>
          <textarea placeholder="请填写您的详细地址、街道、门牌号" v-model="addressDetail" @focus="addressDetailFocus"></textarea>
          <div class="errmes" v-if="addressDetailShow == 1">
            <i></i>详细地址不能为空
          </div>
        </div>
        <div class="label width yu_fl">
          <div class="left">收货人：</div>
          <input type="text" v-model="addressName" @focus="addressNameFocus">
          <div class="errmes" v-if="addressNameShow == 1">
            <i></i>收货人不能为空
          </div>
        </div>
        <div class="label width yu_fr">
          <div class="left">手机号码：</div>
          <input type="text" maxlength="11" v-model="addressPhone" @focus="addressPhoneFocus">
          <div class="errmes" v-if="addressPhoneShow == 1">
            <i></i>{{addressPhoneMessage}}
          </div>
        </div>
        <div class="labtl_btn">
          <div class="default" :class="defaults == 1 ? 'active' : ''" @click="onDefault"><i></i>设为默认</div>
          <div class="btns btns_close" @click="addressClose">取消</div>
          <div class="btns btns_submit" @click="onSubmit">确定</div>
        </div>
      </div>
      <div class="yu_back" @click="addressClose"></div>
    </div>
    <!-- 添加地址 -->
    <!-- 删除地址 -->
    <!-- <div class="yu_mask" v-if="addressDelShow == 1">
      <div class="address_del">
        <p>要删除此地址吗？</p>
        <div class="labtl_btn">
          <div class="btns btns_submit" @click="onDelAddr">确定</div>
          <div class="btns btns_close" @click="addressClose">取消</div>
        </div>
      </div>
      <div class="yu_back" @click="addressClose"></div>
    </div> -->
    <!-- 删除地址 -->
  </div>
</template>

<script>
import VDistpicker from 'v-distpicker'
import { addrList, addrAdd, addrUpdate, addrDelete } from '@/api/address'
export default {
  name: 'addrList',
  components: {
    VDistpicker,
  },
  data() {
    return {
      addrArr: [],
      addressShow: 0, // 是否显示添加地址
      // addressDelShow: 0,
      placeholders: {
        province: '请选择',
        city: '请选择',
        area: '请选择',
      },
      select: {
        province: '请选择',
        city: '请选择',
        area: '请选择',
      },
      areaCode: '',
      addressName: '', // 收件人
      addressNameShow: 0,
      addressPhone: '', // 收件人电话
      addressPhones: '',
      addressPhoneShow: 0,
      addressPhoneMessage: '',
      addressDetail: '', // 详情地址
      addressDetailShow: 0,
      addressId: '', // 当前选择地址id
      defaults: 0, // 默认地址
    }
  },
  created() {
    console.log(this.$route.query.key)
    this.$emit('getUser', this.$route.query.key)
    this.getAddress()
  },
  methods: {
    async getAddress() {
      let _this = this
      const res = await addrList()
      console.log(res)
      if (res.code == 200) {
        _this.goodsAddress = res.data
      }
    },
    addrSplit(name) {
      return name.replace(/-/g, '')
      // .replace(/市辖区/g, "市辖区")
    },
    // 添加地址弹窗
    addressAdd() {
      this.addressShow = 1
    },
    // 关闭地址弹窗
    addressClose() {
      this.addressShow = 0
      // this.addressDelShow = 0;
      this.addressName = ''
      this.addressPhone = ''
      this.addressDetail = ''
    },
    onSelected(data) {
      this.areaCode = data.area.code
      console.log(this.areaCode)
    },
    // 是否默认
    onDefault() {
      this.defaults == 1 ? (this.defaults = 0) : (this.defaults = 1)
    },
    // 收件人获取焦点
    addressNameFocus() {
      this.addressNameShow = 0
    },
    // 手机号获取焦点
    addressPhoneFocus() {
      this.addressPhoneShow = 0
    },
    // 详情地址获取焦点
    addressDetailFocus() {
      this.addressDetailShow = 0
    },
    // 添加收货地址
    onSubmit() {
      let _this = this
      let myreg = /^1[345789]\d{9}$/
      if (_this.addressName == '') {
        _this.addressNameShow = 1
      }
      if (_this.addressPhone == '') {
        _this.addressPhoneShow = 1
        _this.addressPhoneMessage = '手机号码不能为空'
      }
      if (!myreg.test(_this.addressPhone)) {
        if (_this.addressPhones != _this.addressPhone) {
          _this.addressPhoneShow = 1
          _this.addressPhoneMessage = '请输入正确的手机号码'
        }
      }
      if (_this.addressDetail == '') {
        _this.addressDetailShow = 1
      }
      console.log(_this.addressPhones)
      if (_this.addressPhones == '') {
        console.log('1')
        if (
          _this.addressName != '' &&
          _this.addressPhone != '' &&
          _this.addressDetail != '' &&
          myreg.test(_this.addressPhone)
        ) {
          addrAdd({
            name: _this.addressName,
            phone: _this.addressPhone,
            postCode: _this.areaCode,
            detailAddress: _this.addressDetail,
            defaultStatus: _this.defaults
          }).then(function(res) {
            console.log(res);
            if (res.code == 200) {
              _this.addressName = ''
              _this.addressNameShow = 0
              _this.addressPhone = ''
              _this.addressPhoneShow = 0
              _this.addressDetail = ''
              _this.addressDetailShow = 0
              _this.getAddress()
              _this.addressShow = 0
            }
          });
          // _this.$http
          //   .post(
          //     `/member/address/add?name=${_this.addressName}&phone=${
          //       _this.addressPhone
          //     }&postCode=${_this.areaCode}&detailAddress=${
          //       _this.addressDetail
          //     }&defaultStatus=${_this.defaults}`
          //   )
          //   .then(function(res) {
          //     console.log(res)
          //     if (res.data.code == 200) {
          //       _this.addressName = ''
          //       _this.addressNameShow = 0
          //       _this.addressPhone = ''
          //       _this.addressPhoneShow = 0
          //       _this.addressDetail = ''
          //       _this.addressDetailShow = 0
          //       _this.getAddress()
          //       _this.addressShow = 0
          //     }
          //   })
        }
      } else {
        console.log('2')
        console.log(_this.areaCode)
        if (
          _this.addressName != '' &&
          _this.addressPhone != '' &&
          _this.addressDetail != ''
        ) {
          if (
            myreg.test(_this.addressPhone) ||
            _this.addressPhones == _this.addressPhone
          ) {
            let id = _this.addressId;
            let params = {
              name: _this.addressName,
              phone: _this.addressPhone,
              postCode: _this.areaCode,
              detailAddress: _this.addressDetail,
              defaultStatus: _this.defaults
            };
            addrUpdate(id, params).then(function(res) {
              console.log(res);
              if (res.code == 200) {
                _this.addressName = ''
                _this.addressNameShow = 0
                _this.addressPhone = ''
                _this.addressPhoneShow = 0
                _this.addressDetail = ''
                _this.addressDetailShow = 0
                _this.getAddress()
                _this.addressShow = 0
              }
            });
            // _this.$http
            //   .post(
            //     `/member/address/update/${_this.addressId}?name=${
            //       _this.addressName
            //     }&phone=${_this.addressPhone}&postCode=${
            //       _this.areaCode
            //     }&detailAddress=${_this.addressDetail}&defaultStatus=${
            //       _this.defaults
            //     }`
            //   )
            //   .then(function(res) {
            //     console.log(res)
            //     if (res.data.code == 200) {
            //       _this.addressName = ''
            //       _this.addressNameShow = 0
            //       _this.addressPhone = ''
            //       _this.addressPhoneShow = 0
            //       _this.addressDetail = ''
            //       _this.addressDetailShow = 0
            //       _this.getAddress()
            //       _this.addressShow = 0
            //     }
            //   })
          }
        }
      }
    },
    // 修改地址
    editAddress(id, name, phone, code, addr, derail, status) {
      let _this = this
      this.addressShow = 1
      this.addressId = id
      this.addressName = name
      this.addressPhone = phone
      this.addressPhones = phone
      this.areaCode = code
      this.addressDetail = derail
      this.defaults = status
      this.select.province = addr.split('-')[0]
      if (addr.split('-')[0] == '北京市') {
        this.select.city = '北京城区'
      } else if (addr.split('-')[0] == '天津市') {
        this.select.city = '天津城区'
      } else if (addr.split('-')[0] == '上海市') {
        this.select.city = '北京城区'
      } else if (addr.split('-')[0] == '香港特别行政区') {
        this.select.city = '香港城区'
      } else if (addr.split('-')[0] == '澳门特别行政区') {
        this.select.city = '澳门城区'
      } else {
        this.select.city = addr.split('-')[1]
      }
      this.select.area = addr.split('-')[2]
    },
    // 设默认地址
    setDefault(id, name, phone, codes, derail) {
      let _this = this
      this.addrArr.forEach(function(value, index) {
        if (value.id == id) {
          value.defaultStatus = 1
        } else {
          value.defaultStatus = 0
        }
      })
      let params = {
        name: name,
        phone: phone,
        postCode: codes,
        detailAddress: derail,
        defaultStatus: 1
      };
      addrUpdate(id, params).then(function(res) {
        console.log(res);
        if (res.code == 200) {
          console.log(res.data)
        }
      });
      // const res = await this.$http.post(
      //   `/member/address/update/${id}?name=${name}&phone=${phone}&postCode=${codes}&detailAddress=${derail}&defaultStatus=1`
      // )
      // const { data: { code, data, message } } = res
      // console.log(res)
      // if (code == 200) {
      //   console.log(data)
      // }
    },
    // 删除地址
    delAddress(id) {
      // this.addressId = id;
      // this.addressDelShow = 1
      this.$confirm('此操作将永久删除地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(async () => {
          const res = await addrDelete(id)
          console.log(res)
          if (res.code == 200) {
            console.log(res.data)
            this.getAddress()
          }
          // const res = await this.$http.post(`/member/address/delete/${id}`)
          // const { data: { code, data, message } } = res
          // console.log(res)
          // if (code == 200) {
          //   console.log(data)
          //   this.getAddress()
          // }
          this.$message({
            type: 'success',
            message: '删除成功!',
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
  },
}
</script>

<style scoped>
@import '../../assets/styles/address.css';
.title {
  width: 100%;
  padding-bottom: 24px;
  overflow: hidden;
}
.title span {
  float: left;
  color: #333;
}
.title a {
  float: right;
  color: #69c;
}
.addr_list {
  border: 1px solid rgba(218, 218, 218, 1);
  border-bottom: none;
}
.addr_list .name {
  width: 138px;
  text-align: center;
}
.addr_list .addr {
  width: 348px;
  text-align: center;
}
.addr_list .cont {
  width: 185px;
  text-align: center;
}
.addr_list .oper {
  width: 150px;
  text-align: center;
}
.addr_list .othe {
  padding-left: 15px;
}
.addr_title {
  width: 100%;
  height: 48px;
  background: rgba(245, 245, 245, 1);
  overflow: hidden;
}
.addr_title h3 {
  float: left;
  color: #999;
  line-height: 48px;
  text-align: center;
}
.addr_box {
  width: 100%;
  border-bottom: 1px solid rgba(218, 218, 218, 1);
  overflow: hidden;
}
.addr_box li {
  float: left;
  color: #333;
  height: 110px;
}
.addr_box em {
  height: 110px;
  line-height: 1.5;
  font-style: normal;
  display: table-cell;
  vertical-align: middle;
}
.addr_box li.addr em {
  text-align: left;
  word-break: break-all;
}
.addr_box li.oper em {
  color: #69c;
  font-size: 0;
}
.addr_box li.oper span {
  padding: 0 10px;
  cursor: pointer;
}
.addr_box li.othe .normal {
  display: block;
  width: 106px;
  height: 30px;
  color: rgba(180, 160, 120, 1);
  line-height: 28px;
  text-align: center;
  background: rgba(245, 243, 239, 1);
  border: 1px solid rgba(180, 160, 120, 1);
  border-radius: 2px;
}
.addr_box li.othe .active {
  color: #69c;
  cursor: pointer;
}
.no_result a {
  display: block;
  width: 120px;
  height: 36px;
  line-height: 34px;
  color: #b4a078;
  font-size: 20px;
  margin: 0 auto;
  background: rgba(245, 243, 239, 1);
  border: 1px solid rgba(180, 160, 120, 1);
  border-radius: 2px;
}
</style>